import React from 'react';
import {
    Table,
    TableHead,
    TableCell,
    TableRow,
    TableBody,
} from "@material-ui/core";
import Tooltip from '@material-ui/core/Tooltip';
import RemoveIcon from "@material-ui/icons/Close";
import {appConstants} from "../../_constants";

const AddedPassengers = ({ classes, passengers, removePassenger }) => {

    return (
        <div style={{ marginBottom: '15px' }}>
            <Table className={classes.table} aria-labelledby="tableTitle">
                <TableHead className={classes.negativeColor} color="primary">
                    <TableRow>
                        <TableCell padding="none">S/N</TableCell>
                        <TableCell padding="none">Ticket Number</TableCell>
                        <TableCell padding="none">Ticket Type</TableCell>
                        <TableCell padding="none">Ticket Class</TableCell>
                        <TableCell padding="none">Action</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {passengers.map((item, key) => {
                        return (
                            <TableRow hover key={key}>
                                <TableCell>{key + 1}</TableCell>
                                <TableCell padding="none">{item.TicketNumber}</TableCell>
                                <TableCell padding="none">{item.PassengerType}</TableCell>
                                <TableCell padding="none">{item.TicketClass}</TableCell>
                                <TableCell padding="none">
                                    <span>
                                        &nbsp;&nbsp;<Tooltip title="Remove" placement="top">
                                            <span
                                                onClick={() => removePassenger(item.Id_)}
                                                className={classes.icon}
                                                style={{ color: `${appConstants.DANGER_COLOR}`, cursor: 'pointer' }}>
                                                <RemoveIcon />
                                            </span>
                                        </Tooltip>
                                    </span>
                                </TableCell>
                            </TableRow>
                        )
                    })}
                </TableBody>
            </Table>

        </div>
    )
}

export default AddedPassengers


// WEBPACK FOOTER //
// ./src/views/AirlinesPassenger/AddedPassengers.jsx